import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import ResbuildmngCovarage from "./ResbuildmngCovarage"
import ResbuildmngBuildinglife from "./ResbuildmngBuildinglife"
import AddIcon from "@material-ui/icons/Add"
import ResbuildmngFinanceMedic from "./ResbuildmngFinanceMedic";
import ResbuildmngBuildingType from "./ResbuildmngBuildingType";
import ResbuildmngBuildingTypeOfCons from "./ResbuildmngBuildingTypeOfCons";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceResbuildmng extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  resbuildmng_price_id: "",
                  resbuildmng_price_fromyear: "",
                  resbuildmng_price_amount: "",
                  resbuildmng_price_toyear: "",
                  resbuildmng_price_chashdisc: "",
                  resbuildmng_price_disc: "",
                  selectedCompany: "",
                  selectedKind: "",
                  selectedFinancemedic: "",
                  selectedTypeofcons: "",
                  resbuildmng_price_deactive: "0",
                  resbuildmng_price_process_mode: "0",
                  company_logo_url: "",
                  orderBy: "resbuildmng_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceResbuildmng: true,
                  optionCompany: [],
                  optionKind: [],
                  optionFinancemedic: [],
                  optionTypeofcons: [],
                  openDialog: false,
                  resBuildmngCovarage: [],
                  resBuildmngFinanceMedic: [],
                  resbuildmngBuildinglife: [],
                  resbuildmngBuildingType: [],
                  resbuildmngBuildingTypeOfCons: [],
                  resbuildmng_price_covarage_percent: "",
                  resbuildmng_price_buildinglife_percent: "",
                  resbuildmng_price_kind_percent: "",
                  resbuildmng_price_typeofcons_percent: "",
                  selectedResbuildmngCoverage: "",
                  selectedResbuildmngBuildinglife: "",
                  selectedResbuildmngBuildingُType: "",
                  selectedResbuildmngBuildingُTypeOfCons: "",
                  from_unit: "",
                  to_unit : ""
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleChangeFromYear = (event) => {
            this.setState({ resbuildmng_price_fromyear: event })
      }

      handleChangeAmount = (event) => {
            this.setState({ resbuildmng_price_amount: event })
      }

      handleChangeToYear = (event) => {
            this.setState({ resbuildmng_price_toyear: event })
      }
      handleChangeFromUnit = (event) => {
            this.setState({ from_unit: event })
      }
      handleChangeToUnit = (event) => {
            this.setState({ to_unit: event })
      }
      handleChangeDisc = (event) => {
            this.setState({ resbuildmng_price_disc: event })
      }
      handleFinancemedic = (selectedFinancemedic) => {
            this.setState({ selectedFinancemedic: selectedFinancemedic }, () => {})
      }

      handleTypeofcons = (selectedTypeofcons) => {
            this.setState({ selectedTypeofcons: selectedTypeofcons }, () => {})
      }

      handleKind = (selectedKind) => {
            this.setState({ selectedKind: selectedKind }, () => {
                  this.filterPriceResbuildmng()
            })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceResbuildmng()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ resbuildmng_price_deactive: "0" })
            } else {
                  this.setState({ resbuildmng_price_deactive: "1" })
            }
      }
      handleChangeProcessMode = (event) => {
            if (event.target.checked) {
                  this.setState({ resbuildmng_price_process_mode: "1" })
            } else {
                  this.setState({ resbuildmng_price_process_mode: "0" })
            }
      }

      handleResbuildmngCoverage = (selectedResbuildmngCoverage) => {
            this.setState({ selectedResbuildmngCoverage: selectedResbuildmngCoverage })
      }

      handleResbuildmngBuildinglife = (selectedResbuildmngBuildinglife) => {
            this.setState({ selectedResbuildmngBuildinglife: selectedResbuildmngBuildinglife })
      }
      handleResbuildmngBuildingType = (selectedResbuildmngBuildingُType) => {
            this.setState({ selectedResbuildmngBuildingُType: selectedResbuildmngBuildingُType })
      }
      handleResbuildmngBuildingTypeOfCons = (selectedResbuildmngBuildingُTypeOfCons) => {
            this.setState({ selectedResbuildmngBuildingُTypeOfCons: selectedResbuildmngBuildingُTypeOfCons })
      }

      handleChangeExtrafinancialPrice = (event) => {
            this.setState({ resbuildmng_price_covarage_percent: event })
      }

      handleChangeResbuildmngBuildinglife = (event) => {
            this.setState({ resbuildmng_price_buildinglife_percent: event })
      }
      handleChangeResbuildmngBuildingType = (event) => {
            this.setState({ resbuildmng_price_kind_percent: event })
      }
      handleChangeResbuildmngBuildingTypeOfCons = (event) => {
            this.setState({ resbuildmng_price_typeofcons_percent: event })
      }

      handleSelectRows = (row2) => {
            this.getpriceCovarage(row2.resbuildmng_price_id)
            this.getpriceFinanceMedic(row2.resbuildmng_price_id)
            this.getresbuildmngBuildinglife(row2.resbuildmng_price_id)
            this.getresbuildmngBuildingType(row2.resbuildmng_price_id)
            this.getresbuildmngBuildingTypeOfCons(row2.resbuildmng_price_id)

            this.setState(
                  {
                        resbuildmng_price_id: row2.resbuildmng_price_id,
                        resbuildmng_price_fromyear: row2.resbuildmng_price_fromyear,
                        // resbuildmng_price_amount: row2.resbuildmng_price_amount,
                        resbuildmng_price_toyear: row2.resbuildmng_price_toyear,
                        // resbuildmng_price_chashdisc: row2.resbuildmng_price_chashdisc,
                        resbuildmng_price_disc: row2.resbuildmng_price_disc,

                        selectedCompany: { value: row2.resbuildmng_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                        selectedKind: { value: row2.resbuildmng_price_kind_id, label: row2.resbuildmng_kind_name },
                        selectedTypeOfCons: { value: row2.resbuildmng_price_typeofcons_id, label: row2.resbuildmng_typeofcons_name },
                        selectedFinancemedic: { value: row2.resbuildmng_price_financemedic_id, label: row2.resbuildmng_financemedic_name },
                        selectedTypeofcons: { value: row2.resbuildmng_price_typeofcons_id, label: row2.resbuildmng_typeofcons_name },

                        resbuildmng_price_deactive: row2.resbuildmng_price_deactive,
                        resbuildmng_price_process_mode: row2.resbuildmng_price_process_mode,
                        company_logo_url: row2.company_logo_url,
                        newPriceResbuildmng: false,
                  },
                  () => {}
            )
      }

      newPriceResbuildmng = (event) => {
            this.setState({
                  resbuildmng_price_id: "",
                  resbuildmng_price_fromyear: "",
                  resbuildmng_price_amount: "",
                  resbuildmng_price_toyear: "",
                  resbuildmng_price_chashdisc: "",
                  resbuildmng_price_disc: "",
                  selectedCompany: "",
                  selectedKind: "",
                  selectedFinancemedic: "",
                  selectedTypeofcons: "",
                  resbuildmng_price_deactive: "0",
                  resbuildmng_price_process_mode: "0",
                  company_logo_url: "",
                  newPriceResbuildmng: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getoptionCompany()
                                    self.getoptionKind()
                                    self.getoptionFinancemedic()
                                    self.getoptionTypeofcons()
                                    self.getoptionResbuildmngCoverage()
                                    self.getoptionResbuildmngBuildinglife()
                                    self.getoptionResbuildmngBuildingType()
                                    // self.getoptionResbuildmngBuildingTypeOfCons()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteManagdiscount = () => {
            const { resbuildmng_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceResbuildmng()
                              self.newPriceResbuildmng()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_resbuildmng_price")
            fd.append("resbuildmng_price_id", resbuildmng_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceResbuildmng() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterPriceResbuildmng()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_price")

            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getpriceCovarage(resbuildmng_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ resBuildmngCovarage: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ resBuildmngCovarage: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_covarage")
                  fd.append("resbuildmng_price_id", resbuildmng_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }
      getpriceFinanceMedic(resbuildmng_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ resBuildmngFinanceMedic: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ resBuildmngFinanceMedic: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_finance_medic")
                  fd.append("resbuildmng_price_id", resbuildmng_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getresbuildmngBuildinglife(resbuildmng_price_id) {
            this.setState({ resbuildmngBuildinglife: [] }, () => {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ resbuildmngBuildinglife: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_buildinglife")
                  fd.append("resbuildmng_price_id", resbuildmng_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }
      getresbuildmngBuildingType(resbuildmng_price_id) {
            this.setState({ resbuildmngBuildingType: [] }, () => {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ resbuildmngBuildingType: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_kind")
                  fd.append("resbuildmng_price_id", resbuildmng_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }
      getresbuildmngBuildingTypeOfCons(resbuildmng_price_id) {
            this.setState({ resbuildmngBuildingTypeOfCons: [] }, () => {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ resbuildmngBuildingTypeOfCons: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_typeofcons")
                  fd.append("resbuildmng_price_id", resbuildmng_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }


      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.getPriceResbuildmng()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "res_build_manage_ins")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionKind = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_kind_id, label: arr.data[k].resbuildmng_kind_name })
                              }
                              self.setState({ optionKind: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_kind")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }
      getoptionTypeOfCons = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_typeofcons_id, label: arr.data[k].resbuildmng_typeofcons_name })
                              }
                              self.setState({ optionKind: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_typeofcons")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }

      getoptionResbuildmngCoverage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_coverage_id, label: arr.data[k].resbuildmng_coverage_name })
                              }
                              self.setState({ optionResbuildmngCoverage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }

      getoptionResbuildmngBuildinglife = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_buildinglife_id, label: arr.data[k].resbuildmng_buildinglife_name })
                              }
                              self.setState({ optionResbuildmngBuildinglife: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_buildinglife")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }
      getoptionResbuildmngBuildingType = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_kind_id, label: arr.data[k].resbuildmng_kind_name })
                              }
                              self.setState({ optionResbuildmngBuildingType: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_kind")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }

      getoptionFinancemedic = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_financemedic_id, label: arr.data[k].resbuildmng_financemedic_name })
                              }
                              self.setState({ optionFinancemedic: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_financemedic")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }


      getoptionTypeofcons = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].resbuildmng_typeofcons_id, label: arr.data[k].resbuildmng_typeofcons_name })
                              }
                              self.setState({ optionResbuildmngBuildingTypeOfCons: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_resbuildmng_typeofcons")
            xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
            xhttp.send(fd)
      }

      saveNewPriceResbuildmng = () => {
            const {
                  resbuildmng_price_fromyear,
                  resbuildmng_price_toyear,
                  resbuildmng_price_disc,
                  selectedCompany,
                  resbuildmng_price_deactive,
                  resbuildmng_price_process_mode,
            } = this.state
            if (
                  selectedCompany != "" &&
                  resbuildmng_price_fromyear != "" &&
                resbuildmng_price_toyear != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceResbuildmng()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_resbuildmng_price")
                  fd.append("resbuildmng_price_fromyear", resbuildmng_price_fromyear)
                  fd.append("resbuildmng_price_toyear", resbuildmng_price_toyear)
                  fd.append("resbuildmng_price_disc", resbuildmng_price_disc)
                  fd.append("resbuildmng_price_fieldcompany_id", selectedCompany.value)
                  fd.append("resbuildmng_price_deactive", resbuildmng_price_deactive)
                  fd.append("resbuildmng_price_process_mode", resbuildmng_price_process_mode)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResbuildmngCoverage = () => {
            const { resbuildmng_price_id, selectedResbuildmngCoverage, resbuildmng_price_covarage_percent } = this.state
            if (selectedResbuildmngCoverage != "" && resbuildmng_price_covarage_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_covarage_percent: "", selectedResbuildmngCoverage: "" })
                                    self.getpriceCovarage(resbuildmng_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_covarage")
                  fd.append("resbuildmng_price_covarage_resbuildmng_price_id", resbuildmng_price_id)
                  fd.append("resbuildmng_price_covarage_percent", resbuildmng_price_covarage_percent)
                  fd.append("resbuildmng_price_covarage_resbuildmng_covarage_id", selectedResbuildmngCoverage.value)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceResbuildmngFinanceMedic = () => {
            const { resbuildmng_price_id, selectedFinancemedic, from_unit,  to_unit, resbuildmng_price_amount} = this.state
            if (from_unit != "" && to_unit != "" && resbuildmng_price_amount != "" && selectedFinancemedic != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ from_unit : "" , to_unit : "", resbuildmng_price_amount : "" , selectedFinancemedic : "" })
                                    self.getpriceFinanceMedic(resbuildmng_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_finance_medic")
                  fd.append("resbuildmng_price_financemedic_resbuildmng_price_id", resbuildmng_price_id)
                  fd.append("resbuildmng_price_financemedic_resbuildmng_financemedic_id", selectedFinancemedic.value)
                  fd.append("resbuildmng_price_financemedic_from_unit", from_unit)
                  fd.append("resbuildmng_price_financemedic_to_unit", to_unit)
                  fd.append("resbuildmng_price_financemedic_amount", resbuildmng_price_amount)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }


      saveNewPriceResbuildmngBuildinglife = () => {
            const { resbuildmng_price_id, selectedResbuildmngBuildinglife, resbuildmng_price_buildinglife_percent } = this.state
            if (selectedResbuildmngBuildinglife != "" && resbuildmng_price_buildinglife_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_buildinglife_percent: "", selectedResbuildmngBuildinglife: "" })
                                    self.getresbuildmngBuildinglife(resbuildmng_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_buildinglife")
                  fd.append("resbuildmng_price_buildinglife_resbuildmng_price_id", resbuildmng_price_id)
                  fd.append("resbuildmng_price_buildinglife_percent", resbuildmng_price_buildinglife_percent)
                  fd.append("resbuildmng_price_buildinglife_resbuildmng_buildinglife_id", selectedResbuildmngBuildinglife.value)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      saveNewPriceResbuildmngBuildingType = () => {
            const { resbuildmng_price_id, selectedResbuildmngBuildingُType, resbuildmng_price_kind_percent } = this.state
            if (selectedResbuildmngBuildingُType != "" && resbuildmng_price_kind_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_kind_percent: "", selectedResbuildmngBuildingُType: "" })
                                    self.getresbuildmngBuildingType(resbuildmng_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_kind")
                  fd.append("resbuildmng_price_kind_resbuildmng_price_id", resbuildmng_price_id)
                  fd.append("resbuildmng_price_kind_percent", resbuildmng_price_kind_percent)
                  fd.append("resbuildmng_price_kind_resbuildmng_kind_id", selectedResbuildmngBuildingُType.value)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      saveNewPriceResbuildmngBuildingTypeOfCons = () => {
            const { resbuildmng_price_id, selectedResbuildmngBuildingُTypeOfCons, resbuildmng_price_typeofcons_percent } = this.state
            if (selectedResbuildmngBuildingُTypeOfCons != "" && resbuildmng_price_typeofcons_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ resbuildmng_price_typeofcons_percent: "", selectedResbuildmngBuildingُTypeOfCons: "" })
                                    self.getresbuildmngBuildingTypeOfCons(resbuildmng_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_typeofcons")
                  fd.append("resbuildmng_price_typeofcons_resbuildmng_price_id", resbuildmng_price_id)
                  fd.append("resbuildmng_price_typeofcons_percent", resbuildmng_price_typeofcons_percent)
                  fd.append("resbuildmng_price_typeofcons_resbuildmng_typeofcons_id", selectedResbuildmngBuildingُTypeOfCons.value)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }


      changePriceResbuildmng = () => {
            const {
                  resbuildmng_price_id,
                  resbuildmng_price_fromyear,
                  resbuildmng_price_amount,
                  resbuildmng_price_toyear,
                  resbuildmng_price_chashdisc,
                  resbuildmng_price_disc,
                  selectedCompany,
                  selectedKind,
                  selectedFinancemedic,
                  selectedTypeofcons,
                  resbuildmng_price_deactive,
                  resbuildmng_price_process_mode,
            } = this.state
            if (
                  selectedCompany != "" &&
                  resbuildmng_price_fromyear != "" &&
                resbuildmng_price_toyear != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceResbuildmng()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_resbuildmng_price")
                  fd.append("resbuildmng_price_id", resbuildmng_price_id)
                  fd.append("resbuildmng_price_fromyear", resbuildmng_price_fromyear)
                  fd.append("resbuildmng_price_toyear", resbuildmng_price_toyear)
                  fd.append("resbuildmng_price_disc", resbuildmng_price_disc)
                  fd.append("resbuildmng_price_fieldcompany_id", selectedCompany.value)
                  fd.append("resbuildmng_price_deactive", resbuildmng_price_deactive)
                  fd.append("resbuildmng_price_process_mode", resbuildmng_price_process_mode)

                  xhttp.open("POST", `${constants.BASE_URL}/resbuildmng`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceResbuildmng = () => {
            const { selectedCompany, selectedKind, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  console.log(selectedCompany)
                  console.log(temparray[i].resbuildmng_price_fieldcompany_id)
                  if (
                        (selectedCompany.value === 0 || temparray[i].resbuildmng_price_fieldcompany_id === selectedCompany.value) &&
                        (selectedKind === "" || selectedKind.value === 0 || temparray[i].resbuildmng_price_kind_id === selectedKind.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  resbuildmng_price_covarage_percent,
                  resbuildmng_price_buildinglife_percent,
                  resbuildmng_price_kind_percent,
                  resbuildmng_price_typeofcons_percent,
                  selectedResbuildmngCoverage,
                  selectedResbuildmngBuildinglife,
                  selectedResbuildmngBuildingُType,
                  selectedResbuildmngBuildingُTypeOfCons,
                  optionCompany,
                  optionResbuildmngCoverage,
                  optionResbuildmngBuildinglife,
                  optionResbuildmngBuildingType,
                  optionResbuildmngBuildingTypeOfCons,
                  optionKind,
                  optionFinancemedic,
                  optionTypeofcons,
                  resBuildmngCovarage,
                  resBuildmngFinanceMedic,
                  resbuildmngBuildinglife,
                  resbuildmngBuildingType,
                  resbuildmngBuildingTypeOfCons,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceResbuildmng,
                  resbuildmng_price_id,
                  resbuildmng_price_fromyear,
                  resbuildmng_price_amount,
                  resbuildmng_price_toyear,
                  resbuildmng_price_chashdisc,
                  resbuildmng_price_disc,
                  company_logo_url,
                  selectedCompany,
                  selectedKind,
                  selectedFinancemedic,
                  selectedTypeofcons,
                  resbuildmng_price_deactive,
                  resbuildmng_price_process_mode,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                from_unit,
                to_unit
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    {/*PRICE ITSELF*/}
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه مدیران ساختمان: " + resbuildmng_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            {/*<Grid item xs={4}>*/}
                                                            {/*      <div>*/}
                                                            {/*            <label className="on">نوع ملک </label>*/}
                                                            {/*            <Select*/}
                                                            {/*                  isSearchable={true}*/}
                                                            {/*                  className="adapter-txtsize"*/}
                                                            {/*                  placeholder={"نوع ملک "}*/}
                                                            {/*                  value={selectedKind}*/}
                                                            {/*                  onChange={this.handleKind}*/}
                                                            {/*                  options={optionKind}*/}
                                                            {/*            />*/}
                                                            {/*      </div>*/}
                                                            {/*</Grid>*/}

                                                            {/*<Grid item xs={4}>*/}
                                                            {/*      <div>*/}
                                                            {/*            <label className="on">نوع نما </label>*/}
                                                            {/*            <Select*/}
                                                            {/*                  isSearchable={true}*/}
                                                            {/*                  className="adapter-txtsize"*/}
                                                            {/*                  placeholder={"نوع نما"}*/}
                                                            {/*                  value={selectedTypeofcons}*/}
                                                            {/*                  onChange={this.handleTypeofcons}*/}
                                                            {/*                  options={optionTypeofcons}*/}
                                                            {/*            />*/}
                                                            {/*      </div>*/}
                                                            {/*</Grid>*/}

                                                            {/*<Grid item xs={4}>*/}
                                                            {/*      <div>*/}
                                                            {/*            <label className="on"> مالی و پزشکی </label>*/}
                                                            {/*            <Select*/}
                                                            {/*                isSearchable={true}*/}
                                                            {/*                className="adapter-txtsize"*/}
                                                            {/*                placeholder={"مالی و پزشکی"}*/}
                                                            {/*                value={selectedFinancemedic}*/}
                                                            {/*                onChange={this.handleFinancemedic}*/}
                                                            {/*                options={optionFinancemedic}*/}
                                                            {/*            />*/}
                                                            {/*      </div>*/}
                                                            {/*</Grid>*/}


                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="از سال ساخت"
                                                                        handleInputt={this.handleChangeFromYear}
                                                                        value={resbuildmng_price_fromyear}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="تا سال ساخت"
                                                                        handleInputt={this.handleChangeToYear}
                                                                        value={resbuildmng_price_toyear}
                                                                  />
                                                            </Grid>
                                                            {/*<Grid item xs={4}>*/}
                                                            {/*      <FloatingLabelInput*/}
                                                            {/*          type="percent"*/}
                                                            {/*          placeholder="مبلغ حق بیمه هر واحد"*/}
                                                            {/*          handleInputt={this.handleChangeAmount}*/}
                                                            {/*          value={resbuildmng_price_amount}*/}
                                                            {/*      />*/}
                                                            {/*</Grid>*/}

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="تخفیف"
                                                                        handleInputt={this.handleChangeDisc}
                                                                        value={resbuildmng_price_disc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={resbuildmng_price_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={resbuildmng_price_process_mode === "1" ? true : false}
                                                                                          onChange={this.handleChangeProcessMode}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="محاسبه با بازه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newPriceResbuildmng ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.saveNewPriceResbuildmng}
                                                                        >
                                                                              {"ثبت قیمت بیمه مدیر ساختمان جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceResbuildmng}
                                                                              >
                                                                                    {"قیمت بیمه مدیر ساختمان جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceResbuildmng}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه مدیر ساختمان"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceResbuildmng ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    {/*    FINANCE MEDIC COVERAGE  */}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          // <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                          //       {resBuildmngCovarage.map((resBuildmngCovarage, index) => (
                                                          //
                                                          //           <ResbuildmngCovarage
                                                          //               resBuildmngCovarage={resBuildmngCovarage}
                                                          //               props={this.props}
                                                          //               key={index}
                                                          //           />
                                                          //       ))}
                                                          // </Grid>
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {resBuildmngFinanceMedic.map((bfm, index) => (

                                                                    <ResbuildmngFinanceMedic
                                                                        resBuildmngFinanceMedic={bfm}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>

                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>

                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder="از تعداد واحد "
                                                                                handleInputt={this.handleChangeFromUnit}
                                                                                value={from_unit}
                                                                            />
                                                                      </Grid>
                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="number"
                                                                                placeholder=" تا تعداد واحد "
                                                                                handleInputt={this.handleChangeToUnit}
                                                                                value={to_unit}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item xs={3}>
                                                                            <div>
                                                                                  <label className="on"> پوشش مالی پزشکی </label>
                                                                                  <Select
                                                                                      isSearchable={true}
                                                                                      className="adapter-txtsize"
                                                                                      placeholder={"پوشش مالی پزشکی"}
                                                                                      value={selectedFinancemedic}
                                                                                      onChange={this.handleFinancemedic}
                                                                                      options={optionFinancemedic}
                                                                                  />
                                                                            </div>
                                                                      </Grid>



                                                                      <Grid item item xs={2}>
                                                                            <FloatingLabelInput
                                                                                type="currency"
                                                                                placeholder=" قیمت بیمه نامه "
                                                                                handleInputt={this.handleChangeAmount}
                                                                                value={resbuildmng_price_amount}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={2}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewPriceResbuildmngFinanceMedic}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/* EXTRA COVERAGE */}
                                    <Grid item xs={12}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                            <Grid item xs={12}>
                                                                  {resBuildmngCovarage.map((resBuildmngCovarage, index) => (
                                                                        <ResbuildmngCovarage
                                                                              resBuildmngCovarage={resBuildmngCovarage}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> پوشش بیمه</label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"پوشش بیمه"}
                                                                                          value={selectedResbuildmngCoverage}
                                                                                          onChange={this.handleResbuildmngCoverage}
                                                                                          options={optionResbuildmngCoverage}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد پوشش"
                                                                                    handleInputt={this.handleChangeExtrafinancialPrice}
                                                                                    value={resbuildmng_price_covarage_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceResbuildmngCoverage}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    {/*    BUILDING LIFETIME   */}
                                    <Grid item xs={12} >
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {resbuildmngBuildinglife.map((resbuildmngBuildinglife, index) => (
                                                                        <ResbuildmngBuildinglife
                                                                              resbuildmngBuildinglife={resbuildmngBuildinglife}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on">عمر بنا </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"عمر بنا"}
                                                                                          value={selectedResbuildmngBuildinglife}
                                                                                          onChange={this.handleResbuildmngBuildinglife}
                                                                                          options={optionResbuildmngBuildinglife}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد عمر بنا"
                                                                                    handleInputt={this.handleChangeResbuildmngBuildinglife}
                                                                                    value={resbuildmng_price_buildinglife_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceResbuildmngBuildinglife}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/*    TYPE OF BUILDING   */}
                                    <Grid item xs={12} >
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {resbuildmngBuildingType.map((resbuildmngBuildingType, index) => (
                                                                    <ResbuildmngBuildingType
                                                                        resbuildmngBuildingType={resbuildmngBuildingType}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>
                                                                      <Grid item xs={5}>
                                                                            <div>
                                                                                  <label className="on">نوع کاربری </label>
                                                                                  <Select
                                                                                      isSearchable={true}
                                                                                      className="adapter-txtsize"
                                                                                      placeholder={"نوع کاربری"}
                                                                                      value={selectedResbuildmngBuildingُType}
                                                                                      onChange={this.handleResbuildmngBuildingType}
                                                                                      options={optionResbuildmngBuildingType}
                                                                                  />
                                                                            </div>
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder="درصد نوع کاربری"
                                                                                handleInputt={this.handleChangeResbuildmngBuildingType}
                                                                                value={resbuildmng_price_kind_percent}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={3}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewPriceResbuildmngBuildingType}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>


                                    {/*    TYPE OF View BUILDING   */}
                                    <Grid item xs={12} >
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                {resbuildmngBuildingTypeOfCons.map((resbuildmngBuildingTypeOfCons, index) => (
                                                                    <ResbuildmngBuildingTypeOfCons
                                                                        resbuildmngBuildingTypeOfCons={resbuildmngBuildingTypeOfCons}
                                                                        props={this.props}
                                                                        key={index}
                                                                    />
                                                                ))}
                                                          </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceResbuildmng ? null : (
                                                          <Grid item xs={12}>
                                                                <Grid container spacing={3}>
                                                                      <Grid item xs={5}>
                                                                            <div>
                                                                                  <label className="on">نوع نما </label>
                                                                                  <Select
                                                                                      isSearchable={true}
                                                                                      className="adapter-txtsize"
                                                                                      placeholder={"نوع نما"}
                                                                                      value={selectedResbuildmngBuildingُTypeOfCons}
                                                                                      onChange={this.handleResbuildmngBuildingTypeOfCons}
                                                                                      options={optionResbuildmngBuildingTypeOfCons}
                                                                                  />
                                                                            </div>
                                                                      </Grid>

                                                                      <Grid item item xs={4}>
                                                                            <FloatingLabelInput
                                                                                type="percent"
                                                                                placeholder="درصد نوع نما"
                                                                                handleInputt={this.handleChangeResbuildmngBuildingTypeOfCons}
                                                                                value={resbuildmng_price_typeofcons_percent}
                                                                            />
                                                                      </Grid>

                                                                      <Grid item item xs={3}>
                                                                            <div style={{ width: "100%", textAlign: "left" }}>
                                                                                  <Fab
                                                                                      className={classes.small}
                                                                                      color="primary"
                                                                                      aria-label="add"
                                                                                      onClick={this.saveNewPriceResbuildmngBuildingTypeOfCons}
                                                                                  >
                                                                                        <AddIcon />
                                                                                  </Fab>
                                                                            </div>
                                                                      </Grid>
                                                                </Grid>
                                                          </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    {/* THE PRICE*/}
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"resbuildmng_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "resbuildmng_price_id" ? order : false}
                                                                              >
                                                                                    {" آی دی تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "resbuildmng_price_id"}
                                                                                          direction={orderBy === "resbuildmng_price_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("resbuildmng_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"resbuildmng_price_kind_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نوع ملک"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "resbuildmng_price_kind_id"}
                                                                                          direction={
                                                                                                orderBy === "resbuildmng_price_kind_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("resbuildmng_price_kind_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"resbuildmng_price_typeofcons_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نوع ساخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "resbuildmng_price_typeofcons_id"}
                                                                                          direction={
                                                                                                orderBy === "resbuildmng_price_typeofcons_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("resbuildmng_price_typeofcons_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"resbuildmng_price_financemedic_id"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" مالی و پزشکی"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "resbuildmng_price_financemedic_id"}
                                                                                        direction={
                                                                                              orderBy === "resbuildmng_price_financemedic_id"
                                                                                                  ? order
                                                                                                  : "asc"
                                                                                        }
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("resbuildmng_price_financemedic_id")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"resbuildmng_price_fromyear"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"از سال ساخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "resbuildmng_price_fromyear"}
                                                                                          direction={
                                                                                                orderBy === "resbuildmng_price_fromyear"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("resbuildmng_price_fromyear")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"resbuildmng_price_toyear"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تا سال ساخت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "resbuildmng_price_toyear"}
                                                                                          direction={
                                                                                                orderBy === "resbuildmng_price_toyear"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler(
                                                                                                      "resbuildmng_price_toyear"
                                                                                                )
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"resbuildmng_price_amount"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ حق بیمه"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "resbuildmng_price_amount"}
                                                                                        direction={
                                                                                              orderBy === "resbuildmng_price_amount"
                                                                                                  ? order
                                                                                                  : "asc"
                                                                                        }
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler(
                                                                                                  "resbuildmng_price_amount"
                                                                                              )
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>


                                                                              <TableCell
                                                                                    key={"resbuildmng_price_disc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "resbuildmng_price_disc"}
                                                                                          direction={
                                                                                                orderBy === "resbuildmng_price_disc" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("resbuildmng_price_disc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                  key={"resbuildmng_price_chashdisc"}
                                                                                  align={"center"}
                                                                                  style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تخفیف نقدی"}
                                                                                    <TableSortLabel
                                                                                        active={orderBy === "resbuildmng_price_chashdisc"}
                                                                                        direction={
                                                                                              orderBy === "resbuildmng_price_chashdisc" ? order : "asc"
                                                                                        }
                                                                                        onClick={(e) => {
                                                                                              this.createSortHandler("resbuildmng_price_chashdisc")
                                                                                        }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"resbuildmng_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه مدیر ساختمان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "resbuildmng_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "resbuildmng_price_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("resbuildmng_price_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["resbuildmng_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"resbuildmng_price_id"} align={"center"}>
                                                                                                      {row["resbuildmng_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"resbuildmng_price_kind_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_kind_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"resbuildmng_price_typeofcons_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_typeofcons_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"resbuildmng_price_financemedic_id"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_financemedic_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"resbuildmng_price_fromyear"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_fromyear"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"resbuildmng_price_toyear"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_toyear"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"resbuildmng_price_amount"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_amount"]}
                                                                                                </TableCell>


                                                                                                <TableCell
                                                                                                      key={"resbuildmng_price_disc"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_disc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                    key={"resbuildmng_price_chashdisc"}
                                                                                                    align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_chashdisc"]}
                                                                                                </TableCell>


                                                                                                <TableCell
                                                                                                      key={"resbuildmng_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["resbuildmng_price_deactive"] === "1" ||
                                                                                                      row["resbuildmng_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه مدیر ساختمان را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deleteManagdiscount} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceResbuildmng)
